import React from "react";
import { Link } from "react-router-dom";

const HomeHeroGreen = () => {
  return (
    <div className="bg-white py-10 h-[600px]">
      <div className="lg:w-[70%] flex-col md:w-[90%] h-full sm:w-[95%] mx-auto flex justify-center items-center">
        <div className="w-full flex flex-row justify-between">
          <div className="flex flex-col justify-center items-start w-full gap-10 py-10">
            <h1 className="text-8xl space-x-5 space-y-96 text-black align-middle text-left font-signika">
              Find the <br></br> best tutors in <br></br> Bangladesh
            </h1>
            <h1 className="text-2xl  space-x-5 space-y-96 text-green-800 align-middle text-left font-montserrat">
              Connecting You with the Best Tutors in Every Subject.
            </h1>
            <div>
              <button className="px-4 py-2 uppercase rounded-lg bg-green-50 text-green-900 font-roboto text-xl hover:bg-green-200 duration-150">
                Hire Tutor
              </button>
              <Link to="/jobBoard">
                <button className="px-6 uppercase py-2 rounded-lg ml-4 bg-green-500 text-white font-roboto text-xl hover:bg-green-600 hover:text-white duration-150">
                  Get Job
                </button>
              </Link>
            </div>
          </div>
          <div>
            <img
              className="w-[1000px] h-[500px]"
              src="https://i.ibb.co.com/0ygjzL7/eff6cc19-0452-4fef-9626-3bac66857f27-removebg-preview-1.png"
              alt=""
            ></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeHeroGreen;
